import 'nodelist-foreach'
import anime from 'animejs'
import arrayRandom from 'utils/array-random'

let sketch
const sketches = []
const element = document.querySelector('.logobar')

window.addEventListener('load', () => {
  element.initialHeight = 50
})

element.querySelectorAll('svg').forEach(el => {
  el.addEventListener('click', () => toggle({ justForTheTransition: false }))
})

export default {
  get el () { return element },
  get element () { return element },

  get sketch () { return sketch },

  registerSketch: Sketch => sketches.push(Sketch),

  open,
  close,
  toggle
}

function enableScroll () {
  document.body.style.overflow = ''
}

function disableScroll () {
  document.body.style.overflow = 'hidden'
}

function toggle (...args) {
  if (element.isAnimating) return
  return element.isOpen ? close(...args) : open(...args)
}

function open ({ justForTheTransition = true, transitionDuration = 500 } = {}) {
  disableScroll()
  element.isOpen = true
  element.classList.add('is-open')

  return anime({
    targets: element,
    height: [element.initialHeight, window.innerHeight],
    duration: transitionDuration,
    easing: 'easeOutExpo',
    begin: () => {
      element.isAnimating = true
      if (justForTheTransition) return
      loadRandomSketch()
      if (sketch) sketch.willStart()
    },
    complete: () => {
      element.isAnimating = false
      if (justForTheTransition) return
      if (sketch) sketch.didStart()
    }

  }).finished
}

function close ({ transitionDuration = 400 } = {}) {

  enableScroll()
  element.isOpen = false
  element.classList.remove('is-open')

  return anime({
    targets: element,
    height: [window.innerHeight, element.initialHeight],
    duration: transitionDuration,
    easing: 'easeOutExpo',
    begin: () => {
      element.isAnimating = true
      if (sketch) sketch.willClose()
    },
    complete: () => {
      element.isAnimating = false
      if (sketch) {
        sketch.didClose()
        sketch = undefined
      }
    }
  }).finished
}

function loadRandomSketch () {
  const Sketch = arrayRandom(sketches)
  sketch = new Sketch(element)
}
